import http from '../../utils/http.js'

/**
 * Initializes the email verification actions.
 *
 * This function sets up an event listener on the email verification button.
 * When the button is clicked, it sends a POST request to the server to resend
 * the verification email. It also handles the UI updates based on the server's response.
 */
export function initVerifyActions() {
    const verifyEmailButton = document.getElementById('verify-email-button')
    const verifyUserContainer = document.getElementById('verify-user-container')

    if (!verifyEmailButton) return

    verifyEmailButton.addEventListener('click', async (e) => {
        e.preventDefault()
        if (verifyEmailButton.classList.contains('disabled')) return

        verifyEmailButton.classList.add('disabled')

        try {
            const response = await http.post('/signup/verify/send/')
            const data = response.data
            verifyEmailButton.classList.remove('disabled')

            const messageContainer = document.createElement('p')
            verifyUserContainer.innerHTML = ''

            if (!data.error) {
                verifyUserContainer.classList.add('content-information-box--success')
                if (data.data.message) {
                    messageContainer.textContent = data.data.message
                    verifyUserContainer.appendChild(messageContainer)
                }
            } else {
                verifyUserContainer.classList.add('content-information-box--warning')
                if (data.error) {
                    messageContainer.textContent = data.error.message
                    verifyUserContainer.appendChild(messageContainer)
                }
            }
        } catch (error) {
            console.error('Error verifying email:', error)
            verifyEmailButton.classList.remove('disabled')
        }
    })
}
